import React from 'react';
import { HashLink as NavLink } from 'react-router-hash-link';
import Triangle from '../assets/svg/Polygon 1.svg';

function NotificationsModal({
  userNotifications,
  hideNotifications,
  navModels,
  noti,
  navcards,
  currentUser,
  converDate,
}) {
  return (
    <div className='flex justify-end'>
      <div
        className={`w-48 h-8 blue-bg md:-mt-12 -mt-8 z-40 sm:-mt-12  margin-noti margin-notimob text-center cursor-pointer  ${
          userNotifications ? 'flex   flex-col rounded-t-lg ' : 'hidden'
        }`}
        onClick={hideNotifications}
      >
        <img
          className='-mt-2 sm:-ml-6  md:ml-40 lg:ml-32  mr-3'
          src={Triangle}
        />
        <p className='p-2  text-white text-xs  cursor-pointer '>الاشعارات</p>

        <div
          className={`flex  justify-end -mt-1 z-40 ${
            userNotifications ? 'flex ' : 'hidden'
          }`}
        >
          <div
            ref={navModels}
            className='w-48  h-64 bg-white border-2 shadow-md  z-100 
                    overflow-y-auto scrolling-touch  scrollbar-thumb rounded-b-lg'
          >
            <span ref={noti}></span>
            {navcards
              ? Object.keys(navcards).map((key) => {
                  if (navcards[key].cardStatus !== 'completed')
                    return (
                      <span
                        className='block border-b   text-sm font-normal py-2'
                        key={key}
                      >
                        <NavLink to='/activites' className=''>
                          <span className='text-green-400'>
                            {navcards[key].name}
                          </span>
                          <span> </span>
                          طلب مساعدتك منذ
                          <span>
                            {navcards[key].workerCardTime
                              ? converDate(
                                  navcards[key].workerCardTime[currentUser]
                                )
                              : null}
                          </span>
                        </NavLink>
                      </span>
                    );
                })
              : null}
          </div>
        </div>
      </div>
    </div>
  );
}

export default NotificationsModal;
